/* Personalized native dome-reel recommendations; artwork stays in the browser. */
(() => {
  'use strict';
  const root = document.getElementById('logo-recs-demo');
  if (!root) return;
  let art = null, scheduled = false, started = false, visible = false, pending = false;
  const cards = [...root.querySelectorAll('[data-logo-card]')];
  const mapValue = (raw, option) => {
    let map = raw;
    try { if (typeof map === 'string') map = JSON.parse(map); } catch (_) { return null; }
    if (!map || typeof map !== 'object') return null;
    return map[option] || Object.entries(map).find(([key]) => option.toLowerCase().includes(key.toLowerCase()))?.[1];
  };
  const repaint = card => {
    const frame = card.frame, cfg = card.geometry;
    if (!frame || !cfg || !card.shadow?.getElementById('cpdCanvas')) return;
    if (!art?.image || document.getElementById('cpdSkip')?.checked) { frame.hidden = true; return; }
    const doc = card.shadow, canvas = doc.getElementById('cpdCanvas');
    frame.hidden = false;
    const width = frame.clientWidth;
    const size = width * cfg.ratio, height = size * cfg.heightRatio;
    if (!(size > 0 && height > 0)) return;
    canvas.width = Math.round(size * 2); canvas.height = Math.round(height * 2);
    Object.assign(canvas.style, {width:size+'px',height:height+'px',left:cfg.left+'%',top:cfg.top+'%'});
    const ctx = canvas.getContext('2d'); ctx.scale(2,2);
    ctx.fillStyle = art.background || '#fff'; ctx.fillRect(0,0,size,height);
    const w = art.zoom * size, h = w * art.image.naturalHeight / art.image.naturalWidth;
    ctx.drawImage(art.image, size/2 + art.x*size - w/2, height/2 + art.y*size - h/2, w,h);
    const gloss = doc.getElementById('cpdGloss');
    if (gloss) Object.assign(gloss.style,{width:size+'px',height:height+'px'});
    const body = doc.getElementById('cpdBodyView');
    if (body) {
      const geometry = mapValue(cfg.geometries,cfg.option) || cfg.geometry;
      const url = mapValue(cfg.images,cfg.option) || cfg.image || cfg.photo;
      const bodyWidth = size / geometry.d;
      body.src = url; body.hidden = false;
      Object.assign(body.style,{width:bodyWidth+'px',height:'auto',maxWidth:'none',left:(width*cfg.left/100-geometry.cx*bodyWidth)+'px',top:(width*cfg.top/100-geometry.cy*bodyWidth)+'px'});
      if (Array.isArray(geometry.clip) && geometry.clip.length >= 3) {
        body.style.clipPath = 'polygon('+geometry.clip.map(p=>(p[0]*100)+'% '+(p[1]*100)+'%').join(',')+')';
      }
    }
  };
  const paint = () => {
    scheduled = false; cards.forEach(repaint);
  };
  // The carousel sits below the fold. Painting five 2x canvases on every designer
  // redraw would run all through a drag or pinch-zoom, for something nobody is
  // looking at, so defer until it is near the viewport and remember we owe a paint.
  const schedule = () => {
    if (!visible) { pending = true; return; }
    if (!scheduled) { scheduled=true; requestAnimationFrame(paint); }
  };
  // Each prepare() pulls a full product page (about 1 MB) to lift its reel drawing.
  // Five of those is ~5 MB, so it waits for the artwork AND for the carousel to
  // approach the viewport. A customer who uploads and checks out never pays for it.
  const activate = () => {
    if (!visible || started || !art?.image) return;
    started = true;
    Promise.all(cards.map(prepare)).then(schedule);
  };
  async function prepare(card) {
    try {
      const url = new URL(card.dataset.url, location.origin);
      if (root.dataset.previewView) url.searchParams.set('view',root.dataset.previewView);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      const response = await fetch(url.href,{credentials:'same-origin'});
      if (!response.ok) throw new Error('preview unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const data = doc.getElementById('cpdRecommendationGeometry'), stage = doc.getElementById('cpdStage');
      if (!data || !stage) throw new Error('rendering unavailable');
      card.geometry = JSON.parse(data.textContent);
      stage.querySelectorAll('script,#cpdGuide,#cpdPhotoView,#cpdVideoView').forEach(el=>el.remove());
      const styles = [...doc.querySelectorAll('style')].filter(el=>el.textContent.includes('.cpd__stagewrap')).map(el=>el.outerHTML).join('');
      const frame = document.createElement('div'); frame.className='logo-recs-demo__render';
      frame.setAttribute('role','img'); frame.setAttribute('aria-label',card.dataset.title+' with your logo'); frame.hidden = true;
      card.shadow=frame.attachShadow({mode:'open'});
      card.shadow.innerHTML=styles+'<style>:host{display:block}#cpdStage{width:100%;border:0;border-radius:0;box-sizing:border-box;background:#fff}#cpdCanvas{pointer-events:none}</style>'+stage.outerHTML;
      // The curated drawn candidates default to Black or Blue (the SVG default).
      // Match the native designer's Black gradient where required.
      if (card.geometry.option.toLowerCase().includes('black')) {
        card.shadow.getElementById('cpdFaceStop0')?.setAttribute('stop-color','rgba(70,72,76,.88)');
        card.shadow.getElementById('cpdFaceStop1')?.setAttribute('stop-color','rgba(23,25,28,.96)');
        card.shadow.getElementById('cpdStemGroup')?.setAttribute('fill','rgba(23,25,28,.96)');
      }
      const media = card.querySelector('.card__media .media');
      if (!media) return;
      media.append(frame);
      card.frame=frame; schedule();
    } catch (_) { /* Keep the native product image if its rendering is unavailable. */ }
  }
  document.addEventListener('cpd:preview-art',event=>{
    art=event.detail;
    activate();
    schedule();
  });
  new IntersectionObserver(entries=>{
    const now = entries.some(entry=>entry.isIntersecting);
    if (now === visible) return;
    visible = now;
    if (!visible) return;
    activate();
    if (pending) { pending = false; schedule(); }
  },{rootMargin:'400px 0px'}).observe(root);
  document.addEventListener('change',event=>{if(event.target.id==='cpdSkip')schedule();});
  new ResizeObserver(schedule).observe(root);
  window.SPIDCarouselAssets.whenSwiper(()=>{
    const carousel=root.querySelector('.printer-carousel'),sw=carousel.querySelector('.swiper');
    if (sw.dataset.inited) return;
    sw.dataset.inited='1';
    const count=cards.length;
    new window.Swiper(sw,{
      slidesPerView:Math.min(count,2),spaceBetween:14,watchOverflow:true,
      navigation:{prevEl:carousel.querySelector('.swiper-button-prev'),nextEl:carousel.querySelector('.swiper-button-next')},
      breakpoints:{600:{slidesPerView:Math.min(count,4),spaceBetween:14},990:{slidesPerView:Math.min(count,6),spaceBetween:14}},
      on:{resize:schedule}
    });
  });
  // Open another product separately so the customer's current composition stays intact.
  cards.forEach(card=>{
    card.querySelectorAll('a[href]').forEach(link=>{
      const url=new URL(link.href);
      if (root.dataset.previewView) url.searchParams.set('view',root.dataset.previewView);
      const preview=new URLSearchParams(location.search).get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
      link.href=url.href;link.target='_blank';link.rel='noopener';
    });
  });
  document.dispatchEvent(new Event('cpd:request-preview'));
})();
